import { post } from '@/helpers/api'
import store, { setUser, getMyUserId } from '@/store'
import * as rest from '@/api/rest'

export const fetchMyUserInfo = async (hasActivity = false) => {
	try {
		const data = await fetchUserInfo(getMyUserId(), hasActivity)
		return data
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const fetchUserInfo = async (user_id, hasActivity) => {
	try {
		const { data } = await post('/api/v1/user.info', { id: user_id })
		if (hasActivity) {
			data.user.hasactivity = true
		}
		setUser(data.user)

		if (user_id === getMyUserId()) {
			store.auth.setUser(data.user, store.userKey)
		}

		return data
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const searchUsers = async (query, options = {}, config = {}) => {
	try {
		const params = {
			'page[size]': 30,
			'filter[query]': query,
			...options,
		}
		const data = await rest.get('users/search', params, config)
		return data
	} catch (error) {
		if (config?.signal?.aborted) return null
		console.error(error, config)
		return { data: [], error }
	}
}

export const updateUser = async (payload) => {
	const { data } = await post('/api/v1/user.update', payload)
	if (data.ok === false) throw new Error(data.error)
	setUser(data.user)
	return data.user
}

export const updateClientMeta = async (client_meta) => {
	const user_id = getMyUserId()
	return updateUser({ user_id, client_meta })
}
